import { render, staticRenderFns } from "./ProductStockModal.Style#Drawer.vue?vue&type=template&id=5b412680&scoped=true&"
import script from "./ProductStockModal.Style#Drawer.vue?vue&type=script&lang=js&"
export * from "./ProductStockModal.Style#Drawer.vue?vue&type=script&lang=js&"
import style0 from "./ProductStockModal.Style#Drawer.vue?vue&type=style&index=0&id=5b412680&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b412680",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pbit/xtkf-a1/s365/env_cloud_web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b412680')) {
      api.createRecord('5b412680', component.options)
    } else {
      api.reload('5b412680', component.options)
    }
    module.hot.accept("./ProductStockModal.Style#Drawer.vue?vue&type=template&id=5b412680&scoped=true&", function () {
      api.rerender('5b412680', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/carnival/basic/stock/modules/ProductStockModal.Style#Drawer.vue"
export default component.exports